import Icon from "assets/icons";
import { AppParamsContext } from "contexts/AppParamsContext";
import { useContext } from "react";

export default function BrandDisplay() {
  const { appParams } = useContext(AppParamsContext);

  if (
    appParams?.styles?.global?.brandDisplay == null ||
    appParams?.styles?.global?.brandDisplay === "none"
  )
    return null;

  return (
    <div className="flex w-full items-center justify-center pb-3 shrink-0">
      {appParams?.styles?.global?.brandDisplay === "barsoft" && (
        <a
          href="https://barsoft.hu"
          target="_blank"
          rel="noreferrer"
          className="w-full flex flex-col items-center justify-center"
        >
          <p>Powered by:</p>

          <div className="w-full h-10">
            <Icon name="barsoftLogo" className="fill-current" />
          </div>
        </a>
      )}
      {appParams?.styles?.global?.brandDisplay === "okeoke" && (
        <a
          href="https://okeoke.hu"
          target="_blank"
          rel="noreferrer"
          className="w-full flex flex-col items-center justify-center"
        >
          <p>Powered by:</p>
          <div className="w-full h-16">
            <Icon name="okeokeLogo" className="fill-current" />
          </div>
        </a>
      )}
    </div>
  );
}
